import { render, staticRenderFns } from "./dispersion-total-card.vue?vue&type=template&id=3b3dae34&scoped=true&"
import script from "./dispersion-total-card.vue?vue&type=script&lang=js&"
export * from "./dispersion-total-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3dae34",
  null
  
)

export default component.exports